var React = require('react');

function ShieldWithDollar (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#006aff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m33 81.11c30-12.28 31-36.11 31-36.11v-31.15c-19.84-2.65-31-11.85-31-11.85s-11.19 9.23-31 11.88v31.12s1 23.85 31 36.13","key":0}),React.createElement("circle",{"cx":"32.99","cy":"41.33","r":"20.66","key":1}),React.createElement("path",{"d":"m33.03 29.81v2.99","key":2}),React.createElement("path",{"d":"m33 41.11c-4.11 0-4.1-4.22-4.1-4.22s0-4.09 4.14-4.09 4 3.17 4 3.17","key":3}),React.createElement("path",{"d":"m28.9 46.24s0 3.18 4.05 3.18 4.13-4.09 4.13-4.09 0-4.22-4.09-4.22","key":4}),React.createElement("path",{"d":"m33.03 49.42v2.99","key":5})]));
}

ShieldWithDollar.defaultProps = {"viewBox":"0 0 65.98 83.13"};

module.exports = ShieldWithDollar;

ShieldWithDollar.default = ShieldWithDollar;
